// extracted by mini-css-extract-plugin
export default {"pageShell":"CreateProject_pageShell__jXOez","contentInner":"CreateProject_contentInner__AUGSQ"};